const localAuction = "L";
const exportAuction = "E";
const Bidding_Through = {
  BuyNow: "BuyNow",
  Auction: "Auction"
}
const auctionTypes = {
  Live_Auction_DateTime: "Live_Auction_DateTime",
  Buy_now_DateTime: "Buy_now_DateTime",
  liveAuction: "live_auction",
  buyNow: "buy_now",
};
const carApprovalStatus = {
  "pending": 0,
  "approve": 1,
  "disapprove": 2
};
const localAuctionTimeInMins = 95;
const exportAuctionTimeInMins = 60;
const buyNowAuctionTimeInMins = 1440;
const negotiationTimeInMins = 720;

export {
  localAuction,
  exportAuction,
  Bidding_Through,
  auctionTypes,
  carApprovalStatus,
  localAuctionTimeInMins,
  exportAuctionTimeInMins,
  buyNowAuctionTimeInMins,
  negotiationTimeInMins
};